import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } from 'recharts'

interface Props {
  readonly data: Record<string, number>
}

const ACTION_LABELS: Record<string, string> = {
  MOVE_TO_BOOKED: 'Booked',
  UPDATE_FIELDS_ONLY: 'Fields Updated',
  CREATE_OPPORTUNITY: 'Created Opp',
  NO_ACTION: 'No Action',
}

const ACTION_CHART_COLORS: Record<string, string> = {
  MOVE_TO_BOOKED: 'hsl(142, 71%, 45%)',
  UPDATE_FIELDS_ONLY: 'hsl(217, 91%, 60%)',
  CREATE_OPPORTUNITY: 'hsl(262, 83%, 58%)',
  NO_ACTION: 'hsl(220, 9%, 46%)',
}

export function ActionDistributionChart({ data }: Props) {
  const entries = Object.entries(data)
  if (entries.length === 0) {
    return (
      <Card>
        <CardHeader><CardTitle className="text-sm font-medium">Action Distribution</CardTitle></CardHeader>
        <CardContent>
          <div className="flex items-center justify-center h-48 text-sm text-muted-foreground">No data</div>
        </CardContent>
      </Card>
    )
  }

  const formatted = entries
    .map(([action, count]) => ({
      action: ACTION_LABELS[action] ?? action,
      count,
      fill: ACTION_CHART_COLORS[action] ?? 'hsl(220, 9%, 46%)',
    }))
    .sort((a, b) => b.count - a.count)

  return (
    <Card>
      <CardHeader><CardTitle className="text-sm font-medium">Action Distribution</CardTitle></CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={formatted} layout="vertical">
            <XAxis type="number" tick={{ fontSize: 12 }} />
            <YAxis type="category" dataKey="action" tick={{ fontSize: 12 }} width={100} />
            <Tooltip />
            <Bar dataKey="count" name="Count" radius={[0, 4, 4, 0]}>
              {formatted.map((entry, idx) => (
                <rect key={idx} fill={entry.fill} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  )
}
